export function Footer() {
    return (
        <footer>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '5px'}}>
                <p style={{textAlign: 'center', fontWeight: 800, fontSize: '25px'}}>Pempem</p>
                <p style={{textAlign: 'center'}}>Nikmati Berniaga Sawit Yang Transparan, Jujur dan Adil Pempem: Beli Lebih Banyak Buah, Dengan Keberlanjutan</p>
            </div>
        </footer>

    )
}